import dayjs from "dayjs";
import { lngDetect } from "../../../../helpers/lngDetect";
import Image from "../../../elements/Image";
import AvatarUpload from "../../../common/AvatarUpload";
import { initialsValue } from "../../../../helpers";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { TiptapContent } from "../../../elements/tiptap-editor/EditorComponent";
import { t } from "i18next";

const EventDetails = ({ data }) => {
  const { lang } = useSelector((state) => state?.langProvider);
  const { session } = useSelector((state) => state?.authProvider);

  return (
    <>
      <div className="w-full  py-10 px-6 text-slate-800">
        <div className="max-w-6xl mx-auto grid grid-cols-1 lg:grid-cols-3 gap-8 items-start">
          <div className="bg-white/80 backdrop-blur p-6 border-slate-200 group shadow rounded-lg cursor-pointer transition-all duration-300 hover:shadow-xl hover:shadow-primary/10 border border-transparent hover:border-primary/10 hover:no-underline lg:sticky lg:top-3">
            <div className="text-xs font-semibold uppercase tracking-wider text-primary mb-2">{t("Event Information")}</div>
            <div className="text-2xl font-extrabold mb-1">{lngDetect(data?.title || "") || "Untitled Event"}</div>
            <div className="text-sm text-slate-500 mb-6">
              {t("Hosted by")} {data?.userData?.firstName} {data?.userData?.lastName}
            </div>
            <div className="space-y-3">
              <div className="flex items-center gap-2 text-slate-600 text-sm">
                <div className="w-8 h-8 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0 border border-primary/10">
                  <i className="fas fa-location-dot text-primary"></i>
                </div>
                {data?.address?.name}
              </div>
              <div className="flex items-center gap-2 text-slate-600 text-sm">
                <div className="w-8 h-8 rounded-md bg-primary/10 flex items-center justify-center flex-shrink-0 border border-primary/10">
                  <i className="fas fa-calendar-days text-primary"></i>
                </div>{" "}
                {dayjs(data?.startDate).format("ddd, MMM DD, YYYY")} ·{dayjs(data?.startDate).format("hh:mm A")} –{" "}
                {dayjs(data?.endDate).format("ddd, MMM DD, YYYY")} ·{dayjs(data?.endDate).format("hh:mm A")}
                IST
              </div>
            </div>
            <div className="mt-6 bg-gradient-to-br from-slate-50 to-white p-4 rounded-xl border border-slate-100 shadow-inner space-y-2 text-sm">
              <div className="flex justify-between items-center">
                <span className="text-slate-500 font-medium">{t("Status")}:</span>
                <span className="bg-primary/10 capitalize text-green-700 px-2 py-0.5 rounded-full text-xs font-semibold">{data?.status}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-slate-500 font-medium">{t("Visibility")}:</span>
                <span className="bg-blue-100 capitalize text-deep-purple px-2 py-0.5 rounded-full text-xs font-semibold">{data?.visibility}</span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-slate-500 font-medium">{t("Location")}:</span>
                <span className="bg-purple-100 capitalize text-deep-purple px-2 py-0.5 rounded-full text-xs font-semibold">
                  {data?.locationStatus}
                </span>
              </div>
              <div className="flex justify-between items-center">
                <span className="text-slate-500 font-medium">{t("Created At")}:</span>
                <span className="text-slate-500 px-2 py-0.5 text-xs font-semibold">{dayjs(data?.createdAt).format("DD MMM YYYY, hh:mm A")}</span>
              </div>
            </div>

            {session?.user?.role === "admin" ? (
              <>
                <div className="text-xs font-semibold uppercase tracking-wider text-primary mt-10 mb-5">{t("Organization")}</div>
                <div className="flex items-start gap-4">
                  <div className="w-20 h-20 flex-shrink-0 rounded-xl overflow-hidden bg-gray-100 shadow">
                    {data?.organizationData?.logo?.url ? (
                      <img
                        src={data?.organizationData?.logo?.url}
                        alt={lngDetect(data?.organizationData?.name)}
                        className="w-full h-full object-cover"
                      />
                    ) : (
                      <div className="w-full h-full flex items-center justify-center text-xs text-gray-400">No Image</div>
                    )}
                  </div>
                  <div className="flex-1 min-w-0">
                    <h3 className="text-lg font-semibold text-gray-900 break-words leading-snug">{lngDetect(data?.organizationData?.name)}</h3>
                  </div>
                </div>
              </>
            ) : (
              <div className="mt-6">
                <Link
                  to={`/${lang}/user/events/event-manage/${data?.uid}`}
                  className="text-white text-sm font-medium bg-primary-gradient px-6 rounded-full hover:opacity-90 transition-all duration-300 py-3"
                >
                  {t("Manage Event")} →
                </Link>
              </div>
            )}
          </div>
          <div className="lg:col-span-2 space-y-8">
            <div className="relative">
              <h2 className="text-2xl font-semibold text-deep-purple mb-4">{t("About This Event")}</h2>
              <div className="description-content">
                <h6>{t("Event Description")}:</h6>
                <p>
                  {lngDetect(data?.excerpt)}
                  <br />
                </p>
                {/* <h6>Facilities Provided:</h6>
                <ul>
                  <li>Free Wi-Fi across the venue</li>
                  <li>Complimentary lunch and refreshments</li>
                  <li>On-site parking for attendees</li>
                  <li>
                    Accessible restrooms and ramps for differently-abled guests
                  </li>
                  <li>Charging stations and tech support desks</li>
                  <li>
                    Event app with live schedule updates and networking tools
                  </li>
                  <li>Exclusive swag bags for early registrants</li>
                  <li>
                    VIP lounge and private meeting rooms (VIP ticket holders)
                  </li>
                </ul>
                <h6>What to Expect:</h6>
                <ol>
                  <li>Keynotes by industry leaders</li>
                  <li>Tech startup exhibition booths</li>
                  <li>Skill-building workshops</li>
                  <li>Investor meetups and networking lounges</li>
                  <li>Live Q&amp;A and panel discussions</li>
                </ol>
                <h6>Tickets:</h6>
                <ul data-type="taskList">
                  <li>General Admission: $199</li>
                  <li>Student Pass: $99</li>
                  <li>VIP Access: $399</li>
                </ul>
                <p>
                  <strong>Contact Email:</strong>{" "}
                  <a
                    target="_blank"
                    rel="noopener noreferrer nofollow"
                    href="mailto:info@futuretechevents.com"
                  >
                    info@futuretechevents.com
                  </a>
                </p> */}
              </div>
              {data?.overView?.map((over_view, i) => (
                <div key={over_view?._id}>
                  {over_view?.type === "text" && <TiptapContent data={lngDetect(over_view?.content)} />}
                  {over_view?.type === "image" && over_view?.file?.url && (
                    <Image src={over_view?.file?.url} effect={"fade"} alt={over_view?.file?.url} />
                  )}
                  {over_view?.type === "link" && (
                    <a rel="noreferrer" target="_blank" href={over_view?.url || "#"}>
                      {over_view?.url}
                    </a>
                  )}
                </div>
              ))}
            </div>
            {data?.gallery && (
              <div className="relative">
                <h2 className="text-2xl font-semibold text-deep-purple mb-4">{t("Gallery")}</h2>
                <div className="grid grid-cols-2 md:grid-cols-4 gap-4">
                  {data?.gallery?.map((img, idx) => (
                    <div
                      key={idx}
                      className="overflow-hidden rounded-xl border border-slate-200 shadow-sm hover:shadow-lg transition-shadow duration-200"
                    >
                      <Image
                        src={img.url}
                        alt={img.filename}
                        classes="!w-full !h-40 object-cover hover:scale-105 transition-transform duration-300 ease-out"
                      />
                    </div>
                  ))}
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </>
  );
};

export default EventDetails;
